// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M3 1H15.4142L21 6.58579V11.6241C20.0813 11.2227 19.0667 11 18 11C13.8579 11 10.5 14.3579 10.5 18.5C10.5 20.1884 11.0579 21.7465 11.9995 23H3V1ZM14.5 3V7.5H19L14.5 3Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M17.4142 14.0002L18.4142 13.0002L17 11.5859L13.5858 15.0002L17 18.4144L18.4142 17.0002L17.4142 16.0002H18C19.6569 16.0002 21 17.3433 21 19.0002C21 20.657 19.6569 22.0002 18 22.0002C16.3431 22.0002 15 20.657 15 19.0002V18.0002H13V19.0002C13 21.7616 15.2386 24.0002 18 24.0002C20.7614 24.0002 23 21.7616 23 19.0002C23 16.2387 20.7614 14.0002 18 14.0002H17.4142Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-file-restore-filled')
export default class FileRestoreFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'file-restore-filled',
    }
  }
}
